/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import React from "react";
import { Button } from "@heroui/button";
import { useRouter } from "next/navigation";

interface ReadMoreButtonProps {
  slug: string;
}

const ReadMoreButton: React.FC<ReadMoreButtonProps> = ({ slug }) => {
  const router = useRouter();

  return (
    <Button
      className="bg-ax-primary text-ax-text-color font-medium"
      onPress={() => router.push(`/csr/${slug}`)}
    >
      Read More
    </Button>
  );
};

export default ReadMoreButton;
